import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-62">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1600")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-63">
        <div className="absolute inset-0 bg-mimate-text/60 mix-blend-multiply" data-id="element-64"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-mimate-bg via-transparent to-transparent opacity-90" data-id="element-65"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 text-center mt-16" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl mx-auto" data-id="element-67">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading text-mimate-bg mb-6 leading-tight" data-id="element-68">
            Tu momento.
            <br data-id="element-69" />
            <span className="text-mimate-primary italic" data-id="element-70">Tu ritual.</span>
            <br data-id="element-71" />
            Tu lugar.
          </h1>

          <p className="text-lg md:text-xl text-mimate-bg/90 mb-10 font-body max-w-2xl mx-auto leading-relaxed" data-id="element-72">
            En Mímate Studio, creemos que tú eres la primera en tu lista. Uñas,
            cabello y masajes diseñados para resaltar tu poder.
          </p>

          <motion.a whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} href="https://wa.me/525554362239?text=Hola%20Valentina%20quiero%20agendar%20una%20cita%20en%20Mimate%20Studio" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-mimate-primary text-white font-semibold px-8 py-4 rounded-full text-lg shadow-lg hover:bg-mimate-primary/90 transition-colors" data-id="element-73">
            Quiero mi cita ahora <span className="ml-2" data-id="element-74">→</span>
          </motion.a>
        </motion.div>
      </div>
    </section>;
}